import React from 'react'
import { SizableText, TextLink, YStack, Container, Stack } from '@my/ui'
import { KeyboardAwareScrollView, Logo, MainLayout, Meta } from 'app/components'
import { LogInForm, LogInFormValues } from './components'
import { useRouter } from 'solito/router'

export interface LogInScreenProps {
  loading: boolean
  error?: string
  onSubmit: (values: LogInFormValues) => void
  isEmbed?: boolean
}

export const LogInScreen = (props: LogInScreenProps) => {
  const MainContainer = props.isEmbed ? React.Fragment : MainLayout
  const router = useRouter()

  return (
    <MainContainer>
      <Meta title="Log in" />

      <KeyboardAwareScrollView style={{ flex: 1 }}>
        <Container gap="$3" flexGrow={1} size="xs" ai="center" spaceTop spaceBottom gutter>
          <Logo my="$3.5" width={90} />
          <YStack gap="$4" jc="flex-start" ai="center" w="100%">
            <SizableText px="$4" textAlign="center" size="$7" fow="700">
              Login to your Student Saviour account
            </SizableText>
            <LogInForm loading={props.loading} error={props.error} onSubmit={props.onSubmit} />
            {!props.isEmbed && (
              <YStack gap="$1" ai="center" pt="$2">
                <SizableText fow="400">
                  Don't have an account?{' '}
                  <TextLink fow="600" href="/sign-up">
                    Sign up
                  </TextLink>
                </SizableText>
                <SizableText fow="400">
                  Forgot your password?{' '}
                  <TextLink fow="600" href="/forgot-password">
                    Reset password
                  </TextLink>
                </SizableText>
              </YStack>
            )}
            {props.isEmbed && (
              <YStack gap="$1" ai="center" pt="$2">
                <SizableText
                  fow="400"
                  onPress={() => router.back()}
                  textDecorationLine="underline"
                  color="$grey8"
                >
                  Go back
                </SizableText>
              </YStack>
            )}
          </YStack>
        </Container>
      </KeyboardAwareScrollView>
    </MainContainer>
  )
}
